import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const PoinPage = ({ token }) => {
  // Ambil role dan ubah ke huruf kecil semua agar aman dari typo database
  const storedRole = localStorage.getItem('role');
  const userRole = storedRole ? storedRole.trim().toLowerCase() : '';

  const [keyword, setKeyword] = useState('');
  const [siswaList, setSiswaList] = useState([]); 
  const [filteredSiswa, setFilteredSiswa] = useState([]); 
  
  const [selectedSiswa, setSelectedSiswa] = useState(null); 
  const [riwayat, setRiwayat] = useState([]);
  const [loading, setLoading] = useState(false);

  const [jenis, setJenis] = useState('pelanggaran');
  const [poin, setPoin] = useState('');
  const [keterangan, setKeterangan] = useState('');

  const navigate = useNavigate();
  const API_BASE_URL = ''; 

  // 1. Ambil Data Siswa
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/siswa`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
          const dataSiswa = Array.isArray(res.data) ? res.data : [];
          setSiswaList(dataSiswa);
          setFilteredSiswa(dataSiswa);
      })
      .catch(err => console.error(err));
  }, [token]);

  // 2. Live Search
  useEffect(() => {
    if (keyword === '') {
        setFilteredSiswa(siswaList);
    } else {
        const filtered = siswaList.filter(s => 
            (s.nama && s.nama.toLowerCase().includes(keyword.toLowerCase())) || 
            (s.kelas && s.kelas.toLowerCase().includes(keyword.toLowerCase()))
        );
        setFilteredSiswa(filtered);
    }
  }, [keyword, siswaList]);

  // 3. Ambil Riwayat Poin
  const handleSelectSiswa = async (siswa) => {
    setSelectedSiswa(siswa);
    fetchRiwayat(siswa.id);
  };

  const fetchRiwayat = async (id) => {
    try {
        const res = await axios.get(`${API_BASE_URL}/api/poin/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        setRiwayat(Array.isArray(res.data) ? res.data : []);
    } catch (err) { console.error(err); }
  };

  // 4. Submit Poin Baru
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedSiswa) return;
    
    // Otoritas diperluas agar lebih toleran
    const roleDiizinkan = ['admin', 'guru', 'piket', 'wakasek', 'kepsek'];
    if (!roleDiizinkan.includes(userRole)) {
      return Swal.fire('Ditolak!', `Role Anda (${storedRole}) tidak diberi izin menambah poin.`, 'error');
    }

    setLoading(true);

    try {
      await axios.post(`${API_BASE_URL}/api/poin`, {
        siswa_id: selectedSiswa.id,
        jenis,
        poin: parseInt(poin),
        keterangan,
        input_by: 'Guru/Staff' 
      }, { headers: { Authorization: `Bearer ${token}` } });
      
      Swal.fire('Berhasil!', 'Poin tercatat.', 'success');
      setKeterangan('');
      setPoin('');
      fetchRiwayat(selectedSiswa.id); 
    } catch (err) {
      Swal.fire('Error', 'Gagal menyimpan poin ke database.', 'error');
    }
    setLoading(false);
  };

  const totalPelanggaran = riwayat.filter(p => p.jenis === 'pelanggaran').reduce((sum, item) => sum + item.poin, 0);

  return (
    <div style={{ display: 'flex', gap: '20px', height: '85vh', paddingBottom: '20px' }}>
      
      {/* PANEL KIRI */}
      <div style={{ width: '350px', display: 'flex', flexDirection: 'column', background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        <h3 style={{ marginTop: 0, color: '#1e293b' }}>🔍 Cari Siswa</h3>
        <input 
            type="text" 
            placeholder="Ketik Nama / Kelas..." 
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            style={{ padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', marginBottom: '15px', width: '100%', boxSizing: 'border-box' }}
        />
        
        <div style={{ flex: 1, overflowY: 'auto' }}>
            {filteredSiswa.map(s => (
                <div 
                    key={s.id} 
                    onClick={() => handleSelectSiswa(s)}
                    style={{ 
                        padding: '12px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer',
                        background: selectedSiswa?.id === s.id ? '#eff6ff' : 'transparent',
                        borderRadius: '6px'
                    }}
                >
                    <div style={{ fontWeight: 'bold', color: '#334155' }}>{s.nama}</div>
                    <div style={{ fontSize: '12px', color: '#64748b' }}>Kelas: {s.kelas}</div>
                </div>
            ))}
        </div>
      </div>

      {/* PANEL KANAN */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {selectedSiswa ? (
            <>
                <div style={{ background: 'white', padding: '20px', borderRadius: '12px', marginBottom: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h2 style={{ margin: 0, color: '#1e293b' }}>{selectedSiswa.nama}</h2>
                        <p style={{ margin: '5px 0 0', color: '#64748b' }}>Kelas: {selectedSiswa.kelas}</p>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '12px', color: '#64748b' }}>Total Poin Pelanggaran</div>
                        <div style={{ fontSize: '28px', fontWeight: 'bold', color: totalPelanggaran > 50 ? '#dc2626' : '#f59e0b' }}>{totalPelanggaran}</div>
                    </div>
                </div>

                {totalPelanggaran >= 10 && (
                    <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', padding: '15px', borderRadius: '8px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <strong>⚠️ PERINGATAN:</strong> Siswa ini sudah mencapai {totalPelanggaran} poin pelanggaran.
                        </div>
                        <button 
                             onClick={() => navigate(`/surat-peringatan/${selectedSiswa.id}`)}
                             style={{ background: '#b91c1c', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>
                             🖨️ Cetak Surat SP
                        </button>
                    </div>
                )}

                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    {/* FORM INPUT DENGAN TOLERANSI SEBELUM LOGIN ULANG */}
                    {['admin', 'guru', 'piket', 'wakasek', 'kepsek'].includes(userRole) || userRole === '' ? (
                      <div style={{ flex: 1, minWidth: '300px', background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                          <h4 style={{ marginTop: 0 }}>📝 Input Poin Baru</h4>
                          <form onSubmit={handleSubmit}>
                              <div style={{ marginBottom: '10px' }}>
                                  <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Jenis</label>
                                  <select value={jenis} onChange={e => setJenis(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}>
                                      <option value="pelanggaran">❌ Pelanggaran</option>
                                      <option value="prestasi">🏆 Prestasi</option>
                                  </select>
                              </div>
                              <div style={{ marginBottom: '10px' }}>
                                  <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Poin</label>
                                  <input type="number" placeholder="Contoh: 10" value={poin} onChange={e => setPoin(e.target.value)} required style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                              </div>
                              <div style={{ marginBottom: '10px' }}>
                                  <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '5px' }}>Keterangan</label>
                                  <textarea rows="3" placeholder="Contoh: Terlambat..." value={keterangan} onChange={e => setKeterangan(e.target.value)} required style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}></textarea>
                              </div>
                              <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
                                  {loading ? 'Menyimpan...' : 'Simpan Data'}
                              </button>
                          </form>
                      </div>
                    ) : (
                      <div style={{ flex: 1, minWidth: '300px', background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px dashed #cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', textAlign: 'center' }}>
                          ℹ️ Akun Anda ({storedRole}) tidak memiliki otoritas mutasi poin siswa.
                      </div>
                    )}

                    {/* TABEL RIWAYAT */}
                    <div style={{ flex: 1.5, minWidth: '300px', background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                        <h4 style={{ marginTop: 0 }}>📜 Riwayat Poin</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                            <thead>
                                <tr style={{ background: '#f8fafc', textAlign: 'left' }}>
                                    <th style={{ padding: '8px' }}>Tanggal</th>
                                    <th style={{ padding: '8px' }}>Ket</th>
                                    <th style={{ padding: '8px', textAlign: 'center' }}>Poin</th>
                                </tr>
                            </thead>
                            <tbody>
                                {riwayat.map((r, i) => (
                                    <tr key={r.id || i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '8px' }}>{r.tanggal ? String(r.tanggal).substring(0, 10) : '-'}</td>
                                        <td style={{ padding: '8px' }}>
                                            <span style={{ fontWeight: 'bold', color: r.jenis === 'pelanggaran' ? '#ef4444' : '#10b981' }}>
                                              [{r.jenis === 'pelanggaran' ? 'MIN' : 'PLUS'}]
                                            </span> {r.keterangan}
                                        </td>
                                        <td style={{ padding: '8px', textAlign: 'center', fontWeight: 'bold' }}>{r.poin}</td>
                                    </tr>
                                ))}
                                {riwayat.length === 0 && <tr><td colSpan="3" style={{ padding: '20px', textAlign: 'center', color: '#94a3b8' }}>Belum ada data.</td></tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        ) : (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#94a3b8', flexDirection: 'column' }}>
                <span style={{ fontSize: '50px' }}>👈</span>
                <h3>Pilih siswa di sebelah kiri untuk melihat Buku Saku</h3>
            </div>
        )}
      </div>
    </div>
  );
};

export default PoinPage;